import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { PageLayout } from 'containers'
import { EventsList, EventNew, EventShow, EventEdit } from 'containers'

export const EventRouter = () => {
  return (
    <Routes>
      <Route path="/*" element={<PageLayout showBackButton={true} />}>
        <Route index element={<EventsList />} />
        <Route path="new" element={<EventNew />} />
        <Route path=":id" element={<EventShow />} />
        <Route path=":id/edit" element={<EventEdit />} />
      </Route>
    </Routes>
  )
}
